<div [formGroup]="form">
  <div class="tw-grid tw-grid-cols-2 tw-gap-4 tablet:tw-mt-5">
    <div class="sml-control-group tw-col-span-2">
      <label for="name" class="sml-new-label">Title <sup class="tw-text-alert-800">*</sup></label>
      <input id="name" smlPreventLeadingSpace formControlName="name" placeholder="Enter" type="text" class="sml-control"
        [ngClass]="{'sml-control-error': control['name'].invalid && (control['name'].dirty || control['name'].touched)}" />
      <div class="sml-form-error" *ngIf="control['name'].invalid && (control['name'].dirty || control['name'].touched)">
        <p *ngIf="control['name'].errors?.['required'] || control['name'].errors?.['whitespace']" class="tw-text-alert-800">
          Title is required.
        </p>
      </div>
    </div>
    <div class="sml-control-group tw-col-span-2" *ngIf="(campaignType === campaignStatus['Interactive Tour'] || campaignType === 182) || isFromCommunityStories">
      <label for="typeId" class="sml-new-label">Type <sup class="tw-text-alert-800">*</sup></label>
      <sml-search-dropdown formControlName="typeId"  [disabled]="isVolunteerActivity" [items]="isVolunteerActivity ? itemTypesVolunteer : itemTypes" [position]="'bottom'" (controlTouched)="onControlTouched()" [isVolunteerActivity]="isVolunteerActivity" (controlDirty)="onControlDirty()" [isInvalid]="control['typeId'].invalid && (control['typeId'].dirty || control['typeId'].touched)"></sml-search-dropdown>
      <div class="sml-form-error" *ngIf="control['typeId'].invalid && (control['typeId'].dirty || control['typeId'].touched)">
        <p *ngIf="control['typeId'].errors?.['required']" class="tw-text-alert-800">
          Item type is required.
        </p>
      </div>
    </div>
    <!-- <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
      <label for="statusId" class="sml-label">Item Status <sup class="tw-text-alert-800">*</sup></label>
      <sml-radio-button [options]="itemStatusType" formControlName="statusId" groupIdentifier="statusId"
        [disabledOptions]="disabledOptions"></sml-radio-button>
      <div class="sml-form-error" *ngIf="control['statusId'].invalid && (control['statusId'].dirty || control['statusId'].touched)">
        <p *ngIf="control['statusId'].errors?.['required']" class="tw-text-alert-800 tw-flex tw-items-center tw-gap-1">
          <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span>Item status is required.</span>
        </p>
      </div>
    </div> -->
    <div class="sml-control-group tw-col-span-2">
      <label for="itemDescription" class="sml-new-label">Description</label>
      <sml-text-editor [placeholderText]="'Give brief description about this item'" [showCharacterLimitText]="false" formControlName="description"></sml-text-editor>
    </div>
    <!-- <div class="sml-control-group tw-col-span-2">
      <label for="postItem" class="sml-label !tw-block">Post Item <sup class="tw-text-alert-800">*</sup></label>
      <div class="tw-inline-flex tw-w-full">
        <sml-radio-button [options]="itemPostType" formControlName="isPosted" groupIdentifier="postItem" [showSubheadings]="true" [subheadings]="itemPostSubHeadings"
          class="tw-w-full"></sml-radio-button>
      </div>
      <div class="sml-form-error" *ngIf="control['isPosted'].invalid && (control['isPosted'].dirty || control['isPosted'].touched)">
        <p *ngIf="control['isPosted'].errors?.['required']" class="tw-text-alert-800 tw-flex tw-items-center tw-gap-1">
          <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span>Post Item is required.</span>
        </p>
      </div>
    </div> -->
    <ng-content class="sml-control-group tw-col-span-2" select = "[dates]"></ng-content>
    <div class="sml-control-group tw-col-span-2">
      <label for="locationName" class="sml-new-label">Location Name</label>
     
      <input type="text" id="locationName" formControlName="locationName" placeholder="Enter" class="sml-control" />
    </div>
    <div class="sml-control-group tw-col-span-2" *ngIf="(campaignType === campaignStatus['Volunteer Activity']) || (campaignType === campaignStatus['Interactive Tour']) || (campaignType === campaignStatus['Memorial Program']) || (campaignType === campaignStatus.Registration) || (isFromCommunityStories && !campaignType)">
      <span *ngIf="(campaignType===campaignStatus['Volunteer Activity'])" class="sml-new-label">Meet up Address</span>
      <span *ngIf="(campaignType===campaignStatus['Interactive Tour'] || (campaignType === campaignStatus['Memorial Program']) || (campaignType === campaignStatus.Registration) || isFromCommunityStories)" class="sml-new-label">Address</span>
      
      <sml-google-places-autocomplete [address]="control['address'].value" (placeSelected)="onPlaceSelected($event)"></sml-google-places-autocomplete>
      
    </div>
    @if((campaignType===campaignStatus['Interactive Tour'] || (campaignType === campaignStatus['Memorial Program']) || (campaignType === campaignStatus.Registration) || (isFromCommunityStories && !campaignType))){

    <div class="tw-col-span-2">
      <div class="tw-w-full tw-h-5 tw-items-center tw-gap-2 tw-inline-flex">
        <div class="tw-border-t tw-border-dashed tw-border-grey-100 tw-flex-1 tw-h-[1px]">&nbsp;</div>
        <div class="tw-text-mercury-950 tw-text-sm tw-font-mediumtw-leading-tight">OR</div>
        <div class="tw-border-t tw-border-dashed tw-border-grey-100 tw-flex-1 tw-h-[1px]">&nbsp;</div>
      </div>
    </div>

    <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
      <label for="latitude" class="sml-label">Latitude</label>
      <input type="text" id="latitude" formControlName="latitude" placeholder="Enter" class="sml-control" appNumericInput
      [ngClass]="{'sml-control-error': control['latitude'].invalid && (control['latitude'].dirty || control['latitude'].touched)}"/>
      <div class="sml-form-error" *ngIf="control['latitude'].invalid && (control['latitude'].dirty || control['latitude'].touched)">
        <p *ngIf="control['latitude'].errors?.['max'] || control['latitude'].errors?.['min']" class="tw-text-alert-800">
          Invalid latitude. Must be between -90 and 90 degrees.
        </p>
      </div>
    </div>
    <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
      <label for="longitude" class="sml-label">Longitude</label>
      <input type="text" id="longitude" formControlName="longitude" placeholder="Enter" class="sml-control" appNumericInput 
      [ngClass]="{'sml-control-error': control['longitude'].invalid && (control['longitude'].dirty || control['longitude'].touched)}"/>
      <div class="sml-form-error" *ngIf="control['longitude'].invalid && (control['longitude'].dirty || control['longitude'].touched)">
        <p *ngIf="control['longitude'].errors?.['max'] || control['longitude'].errors?.['min']" class="tw-text-alert-800">
          Invalid longitude. Must be between -180 and 180 degrees.
        </p>
      </div>
    </div>
  }

  </div>
</div>
